import React, { Component } from 'react';
import AdminTable from 'layouts/AdminTable';
import withStyles from '@material-ui/core/styles/withStyles';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';
import DataGrid from 'components/DataGrid/DataGrid';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import columnConfig from './columnConfig';

class List extends Component {
  newSize = () => this.props.history.push(`${window.location.pathname}/add`);

  render() {
    return (
      <AdminTable title={this.props.t('reportArchive')}>
        <DataGrid
          minRows={10}
          actions={true}
          remove={false}
          export={false}
          paginationTop={true}
          paginationBottom={false}
          url="export-archives"
          columns={columnConfig(this.props)}
        />
      </AdminTable>
    );
  }
}

const mapStateToProps = state => ({
  user: state.Auth.user,
});

const mapDispatchToProps = {};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(buttonsStyle)(List))
);
